import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path, propOr } from 'ramda';
import { withAsyncActions, withSagas, toSuccess } from 'react-async-client';
import { takeEvery } from 'redux-saga/effects';

import {
    setWorksheetListFilters,
    setWorksheetListSort,
    setWorksheetListPagination,
    setWorksheetListColumnWidth,
    setWorksheetListSelected
} from 'actions/worksheetActions';
import List from 'components/common/List';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { fullAutoOptions } from 'constants/asyncClient';
import { defaultWorksheetColumns } from 'constants/defaultColumns';
import getWorksheetTableTemplate from './cellTemplates/worksheetTableTemplates';
import { getWorksheetList, getWorksheetListSettings, updateEvent, putPersonState, createEvent } from 'actions/asyncActions';
import WorksheetListControls from 'components/views/worksheetList/WorksheetListControls';

const tableConfig = {
    defaultColumns: defaultWorksheetColumns,
    getTemplate: getWorksheetTableTemplate,
    headerTranslatePrefix: 'worksheet.headers.'
};

const dispatchToProps = {
    setPagination: setWorksheetListPagination,
    setSort: setWorksheetListSort,
    setFilters: setWorksheetListFilters,
    setColumnWidth: setWorksheetListColumnWidth,
    setSelected: setWorksheetListSelected
};

@connect(({ table: { worksheet } }) => worksheet, dispatchToProps)
@withAsyncActions({
    getSettings: getWorksheetListSettings
        .withOptions({ dispatchOnMount: true }),
    getList: getWorksheetList
        .withPayload(({ match: { params: { id } } }) => ({ id }))
        .withOptions(fullAutoOptions)
})
@withSagas([function* (getProps) {
    yield takeEvery([toSuccess(putPersonState.type), toSuccess(createEvent.type), toSuccess(updateEvent.type)], () => {
        const props = getProps();
        props.getList.refresh();
    });
}])
@withRouteOptions
export default class WorksheetListView extends Component {
    static routeOptions = {
        title: 'menu.worksheet'
    }

    static propTypes = {
        getList: PropTypes.object.isRequired,
        getSettings: PropTypes.object.isRequired,
        setHeaderTitle: PropTypes.func.isRequired,
    }

    componentDidUpdate({ getList: { meta : oldMeta } }) {
        const { setHeaderTitle, getList: { meta, data } } = this.props;

        if (oldMeta.pending && meta.success) {
            setHeaderTitle({
                title: WorksheetListView.routeOptions.title,
                params: { project: path(['position', '0', 'text'], data) }
            });
        }
    }

    renderControls = (props) => {
        const { getList: { meta } } = this.props;
        return <WorksheetListControls {...props} refreshMeta={meta} />;
    }

    render() {
        const { getList: { data, meta }, getSettings: { data : settings } } = this.props;

        return (
            <List
                meta={meta}
                items={propOr([], 'people', data)}
                settings={settings}

                tableConfig={tableConfig}
                controls={this.renderControls}

                {...this.props}
            />
        );
    }
}
